import keyMirror from 'keymirror';

export const addListsModalActionTypes = keyMirror({
	GET_LIST_REQUEST: null,
	GET_LIST_SUCCESS: null,
	GET_LIST_ERROR: null,

	TOGGLE_ADD_LIST_MODAL: null,
	CLEAR_ADD_LIST_MODAL_STATE: null,
});

export const getFormattedOptions = (options, itemType) => {
	return options.map(({ type = 'list', id, book_id }) => {
		if (itemType === 'addPractiseableItems') {
			const option = { type, id };
			if (book_id) option.book_id = book_id;
			return option;
		}
		return id;
	});
};

export const getMainDDOptions = (t, userData, subjectId) => {
	const mainDDSections = ['books', 'groups', 'folders'];
	const sections = !userData?.books?.length ? mainDDSections.slice(1) : mainDDSections;
	return sections.map((section) => {
		const formattedBody = [];

		// prettier-ignore
		(userData[section] && userData[section].length > 1) ||
		(userData[section] &&
			userData[section].length === 1 &&
			userData[section][0].id.toString() !== subjectId.toString())
			? userData[section].forEach((item) => {
				const iconOrAvatar = item.small_image
					? {
						ava: item.small_image,
						  }
					: item.subject && item.subject.icon_url
						? {
							ava: item.subject.icon_url,
						  }
						: section === 'groups'
							? {
								icon: 'group',
						  }
							: section === 'folders'
								? {
									icon: 'folder',
						  }
								: {};

				if (subjectId && item.id.toString() !== subjectId.toString())
					formattedBody.push({
						title: item.name,
						value: item.id,
						type: section.slice(0, -1),
						subValue: item.book_grade_display,
						additionalSubValue: item.edition_display,
						avaOutside: true,
						...iconOrAvatar,
					});

				if (userData[section][userData[section].length - 1].id === item.id) {
					formattedBody.push(addNewItem(section, t));
				}
			  })
			: formattedBody.push(
				{
					title: t(`modals.add_lists_modal.empty_${section}`),
					disabled: true,
				},
				addNewItem(section, t),
			  );

		return {
			section:
				section && section !== '' ? t(`modals.add_lists_modal.dd_options.${section}`) : '',
			body: formattedBody,
		};
	});
};

export const getlistDDOptions = (t) => ({
	section: t('modals.add_lists_modal.dd_options.lists'),
	body: [
		{
			title: t('modals.add_lists_modal.dd_options.made'),
			value: 'own',
			type: 'own',
			icon: 'writing',
		},
		{
			title: t('modals.add_lists_modal.dd_options.recent'),
			value: 'recent',
			type: 'recent',
			icon: 'history',
		},
	],
});

export const addNewItem = (subject, t) => {
	const elementType = subject.slice(0, -1);
	return {
		title: t(`modals.add_lists_modal.create_new`, {
			context: elementType,
		}),
		icon: 'add',
		className: 'purple',
		type: 'action',
		value: `create_new_${subject}`,
	};
};
